var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 34.865,
    viewBox: "0 0 45 34.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 28.346)",
    d: "M0,6.519H173.48V-28.346H0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.042 10.618h-2.563a17.431 17.431 0 0 0-16.047-10.618 17.432 17.432 0 0 0-17.429 17.433 17.432 17.432 0 0 0 17.429 17.433 17.438 17.438 0 0 0 16.049-10.617h2.561l5.727-6.816z",
    fill: "#e6e7e8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.235 3.235)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(23.083 11.542)",
    d: "m5.308 2.654a14.211 14.211 0 0 0-14.2-14.2 14.211 14.211 0 0 0-14.2 14.2 14.211 14.211 0 0 0 14.2 14.2 14.211 14.211 0 0 0 14.2-14.2m-4.234 0a9.973 9.973 0 0 1-9.962 9.962 9.973 9.973 0 0 1-9.963-9.962 9.973 9.973 0 0 1 9.964-9.962 9.973 9.973 0 0 1 9.962 9.962"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(29.303 8.633)",
    d: "M6.739,1.985H4.176A17.431,17.431,0,0,0-11.871-8.633,17.432,17.432,0,0,0-29.3,8.8,17.432,17.432,0,0,0-11.871,26.233,17.438,17.438,0,0,0,4.178,15.616H6.739L12.466,8.8ZM-11.872,24.136A15.353,15.353,0,0,1-27.206,8.8,15.354,15.354,0,0,1-11.872-6.536,15.354,15.354,0,0,1,3.464,8.8,15.353,15.353,0,0,1-11.872,24.136"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.347 10.04)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(6.641 3.321)",
    d: "M1.527.764A4.116,4.116,0,0,0-4.4-2.913,3.683,3.683,0,0,0-6.259-1.026a4.124,4.124,0,0,0,2.087,5.54v6.948H-.944V4.515A4.086,4.086,0,0,0,1.527.764"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSlider);
export default __webpack_public_path__ + "static/media/logo-slider.9ce06fd2f94e9faf6bdef7efaf0b2a43.svg";
export { ForwardRef as ReactComponent };